import Icon from '@salesforce/design-system-react/components/icon';
import PageHeader from '@salesforce/design-system-react/components/page-header';
import { useNavigate } from 'react-router-dom';
import {
  FactoryEmaillabApiV1Folder,
  FactoryEmaillabApiV1Project
} from '../../app/apiGenerated';
import { BreadCrumb } from '@salesforce/design-system-react';

interface FoldersHeaderProps {
  title: string;
  selectedProject: FactoryEmaillabApiV1Project | undefined;
  path: JSX.Element;
}
const FoldersHeader = ({
  title,
  selectedProject,
  path
}: FoldersHeaderProps) => {
  const navigate = useNavigate();
  const trail = [
    <a id="parent-entity" onClick={() => navigate('/')}>
      Projects
    </a>
  ];

  return (
    <>
      <PageHeader
        icon={
          // <Icon
          //   assistiveText={{ label: 'Folders' }}
          //   category="standard"
          //   name="list_email"
          // />
          <div>
            <img
              src="/assets/dartagnan-logo.png"
              style={{ borderRadius: '4px' }}
            />
          </div>
        }
        //info="6 Items • Updated 13 minutes ago"
        // label="Dartagnan Connector"
        label={
          <BreadCrumb
            assistiveText={{ label: 'Dartagnan Connector' }}
            trail={trail}
          />
        }
        details={[
          {
            label: 'Path',
            content: <>{path}</>
          }
        ]}
        // onRenderActions={actions}
        // onRenderControls={controls}
        title={title}
        variant="record-home"
      />
    </>
  );
};

export default FoldersHeader;
